const Spinner = ({ full = false, label }) => (
  <div className={full ? 'spinner-wrap spinner-wrap--full' : 'spinner-wrap'}>
    <span className="spinner" aria-hidden="true" />
    {label ? <span className="spinner-label">{label}</span> : null}
  </div>
);

export default Spinner;
